const SERVER_URI = "https://my-portfolio-backend-uovo.onrender.com";

module.exports = {
    SERVER_URI
}